import { NODE_RUNTIME_ENV } from '@/core/env';
const { NODE_ENV } = process.env;

const NODE_ENV_SELF = ''; // 自定义的环境参数，通过路由判断

export const isDev = NODE_ENV === 'development' && false;
export const baseURL = NODE_ENV === 'development' ? 'https://rbac-dev.zmnyun.cn/' : '/';
export const scope = 'sdc-admin';
export const appName = 'sdc-admin-rbac';
export const clientPrefix = '/backend';
export const socketURL =
  NODE_ENV === 'development'
    ? 'ws://dev.sdc.sinohealth.cn:30200/webSocket'
    : `ws://${window.location.hostname}:30200/webSocket`;
export const getTokenParams = {
  clientId: 'healthplus-oms',
  clientSecret: 'healthplus-oms',
  scope: 'zmn-rx-oms-server',
};
export const loginRememberKey = 'zk-hccm-w'; // 记住密码时保存数据的key
export const sendCodeTimeKey = 'zk-c-s-c';

const AllAMapConfig = {
  dev: {
    key: '37ce5ef335d62d566fa1e7c4fee741aa', // 开发者key
    securityJsCode: '02ef1d16a425a802915f995b0dd1e254', // 应用密钥
  },
  sit: {
    key: '37ce5ef335d62d566fa1e7c4fee741aa', // 开发者key
    securityJsCode: '02ef1d16a425a802915f995b0dd1e254', // 应用密钥
  },
  demo: {
    key: '514f4701bb2e3b010a99eb7e15687023', // 开发者key
    securityJsCode: '2447364a60e47a84dfe8431c025b9f83', // 应用密钥
  },
  pro: {
    key: 'f6c950eb47725c835afc33f5d3170449', // 开发者key
    securityJsCode: '6b40f4f8561bfa7de49b5822ff3cc20d', // 应用密钥
  },
};
export const AMapConfig = AllAMapConfig[NODE_RUNTIME_ENV]; // 高德地图配置

type ThemeData = {
  borderRadius?: number;
  colorPrimary: string;
};

// 主题色配置
export const currThemeData: ThemeData = {
  colorPrimary: '#217BA0',
};

export default {
  currThemeData,
  baseURL,
  getTokenParams,
};

(global as any).config = {
  app: 'sdc-admin-rbac',
  clientPrefix: '/backend',
  baseURL,
};
